
import React from 'react';

import GridContainer from '../../mui-components/Grid/GridContainer';
import ItemGrid from '../../mui-components/Grid/GridItem';
import RegularCard from '../../mui-components/Card/RegularCard';
import PartnerEnterprisesTable from '../../containers/domain/partner-enterprise/PartnerEnterprisesTable';

const PartnerEnterprisesListingView = () => (
  <GridContainer>
    <ItemGrid xs={12}>
      <RegularCard
        title="Lista de fornecedores"
        content={<PartnerEnterprisesTable />}
      />
    </ItemGrid>
  </GridContainer>
);

export default PartnerEnterprisesListingView;
